import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from "react-bootstrap";
import CancelIcon from "@mui/icons-material/Cancel";
import { logout } from "../redux/handlers/auth/logout.handler";
export default function ModalLogoutCustom(_param) {
    var navigate = _param.navigate, show = _param.show, props = _object_without_properties(_param, [
        "navigate",
        "show"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        logout(navigate, "/login");
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsx(CancelIcon, {
                            color: "error",
                            style: {
                                fontSize: 60
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textlogout
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mt-4",
                        children: /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg px-4",
                            onClick: handleCloseAndNavigate,
                            children: "ปิด"
                        })
                    })
                ]
            })
        })
    }));
}
